import { BehaviorSubject } from 'rxjs';

export const behaviorIconNavigation$ = new BehaviorSubject({});

export const behaviorIconNavigation = behaviorIconNavigation$.asObservable();
